import React from "react";
import { Link } from "react-router-dom";
import { HashLink } from "react-router-hash-link";
// Components
import Box from "@mui/material/Box";
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import MKTypography from "components/MKTypography";
import MKBox from "components/MKBox";
// import ListComponent from "components/CBList";
// Theme
import theme from "assets/theme";
// import FAQDetails from "./components/FAQDetails";
import ListComponent from "components/CBList";
import HeaderContainer from "styles/components/headerContainer";

const FAQContent = ({ items, categoryTextColor, content }) => {
  const currentItems = items?.faqSections || content?.faqSections || content?.faqSections[0];
  const faqSections = Array.isArray(currentItems) ? currentItems : items;
  return (
    <section id="faq-content">
      {Array.isArray(faqSections) ? (
        faqSections.map((item, i) => (
          <MKBox key={i} sx={{ marginTop: i !== 0 && "2rem" }}>
            {item.category && (
              <HeaderContainer
                title={item?.category}
                subtitle={item?.subtitle}
                variant={content?.componentType === "Faq" ? "h2" : "h3"}
                component={"h2"}
                textColor={categoryTextColor || theme.palette.primary.main}
                highlightText={content?.highlightText}
                highlightColor={theme.palette.accent.main}
              />
              // <MKTypography
              //   sx={{ color: `${categoryTextColor} !important` }}
              // variant={content?.componentType === "Faq" ? "h2" : "h3"}
              // component={"h2"}
              //   mb="1rem"
              //   gutterBottom
              // >
              //   {item?.category}
              // </MKTypography>
            )}
            {item.FAQs.map((item, index) => {
              const cta = item?.cta;
              return (
                // Drop down accordion
                <Box
                  component={Accordion}
                  key={index}
                  padding={1}
                  marginBottom={index === item.length - 1 ? 0 : 2}
                  borderRadius={`${theme.spacing(1)} !important`}
                  aria-label={`Expand question ${index + 1}`}
                  sx={{
                    "&::before": {
                      display: "none",
                    },
                  }}
                >
                  {/* Question */}
                  <Box
                    component={AccordionSummary}
                    expandIcon={<ExpandMoreIcon sx={{ color: theme.palette.secondary.main }} />}
                    aria-controls={`panel1a-content-${index + 1}`}
                    id={`panel1a-header-question-${index + 1}`}
                  >
                    <MKTypography variant={"h6"} component={"h3"} sx={{ fontWeight: 500 }}>
                      {item.question}
                    </MKTypography>
                  </Box>
                  {/* faq drop detail */}
                  <AccordionDetails>
                    {/* Answer */}
                    {Array.isArray(item.answer) ? (
                      item.answer.map((answer, index) => {
                        return (
                          <MKTypography
                            component={"p"}
                            variant={"body2"}
                            key={index}
                            gutterBottom
                            sx={{ marginBottom: index === item.answer.length - 1 ? "2rem" : "1rem" }}
                          >
                            {answer}
                          </MKTypography>
                        );
                      })
                    ) : (
                      <MKTypography variant={"body2"} component={"p"} sx={{ marginBottom: "2rem" }}>
                        {item.answer}
                      </MKTypography>
                    )}
                    {/* List component */}
                    {item.answerList && <ListComponent listItems={item.answerList} listType="faq" />}
                    {/* Answer Footer */}
                    {Array.isArray(item.answerFooter) ? (
                      item.answerFooter.map((content, indexsz) => {
                        return (
                          <MKTypography key={indexsz} component="p" variant={"body2"} gutterBottom>
                            {content}
                          </MKTypography>
                        );
                      })
                    ) : (
                      <MKTypography component="p" variant={"body2"}>
                        {item.answerFooter}
                      </MKTypography>
                    )}
                    {/* CTA and Links */}
                    {Array.isArray(cta)
                      ? cta.map(({ text, link, hashLink }, index) => {
                          return (
                            <>
                              {link && (
                                <Link style={{ color: theme.palette.secondary.main }} to={link} key={index}>
                                  <MKTypography sx={{ color: theme.palette.secondary.main }} component="p" variant={"body2"} gutterBottom>
                                    {text}
                                  </MKTypography>
                                </Link>
                              )}
                              {hashLink && (
                                <HashLink style={{ color: theme.palette.secondary.main }} to={hashLink} key={index}>
                                  <MKTypography sx={{ color: theme.palette.secondary.main }} component="p" variant={"body2"} gutterBottom>
                                    {text}
                                  </MKTypography>
                                </HashLink>
                              )}
                            </>
                            // <Link style={{ color: theme.palette.secondary.main }} to={link || hashLink} key={index}>
                            // <MKTypography sx={{ color: theme.palette.secondary.main }} component="p" variant={"body2"} gutterBottom>
                            //   {text}
                            // </MKTypography>
                            // </Link>
                          );
                        })
                      : cta}
                  </AccordionDetails>
                </Box>
              );
            })}
          </MKBox>
        ))
      ) : (
        <p>No FAQ data available.</p>
      )}
    </section>
  );
};

export default FAQContent;
